import axios from "axios";
import { API_BASE_URL } from "../environment";

const authConfig = () => {
  const token = sessionStorage.getItem("token");

  return token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
};

export const createGroup = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/addGroup`, data, authConfig());
  return response.data;
};

export const getAllGroups = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/getAllGroups`, data, authConfig());
  return response.data;
};

export const getGroupById = async (id, data) => {
  const response = await axios.post(`${API_BASE_URL}/group/${id}`, data, authConfig());
  return response.data;
};

export const updateGroup = async (id, data) => {
  const response = await axios.patch(`${API_BASE_URL}/group/${id}`, data, authConfig());
  return response.data;
};

export const deleteGroup = async (id, data) => {
  const response = await axios.post(`${API_BASE_URL}/deleteGroup/${id}`, data, authConfig());
  return response.data;
};

export const assignCustomerToGroup = async (groupId, customerId, data) => {
  const response = await axios.patch(`${API_BASE_URL}/group/${groupId}/customer/${customerId}`, data, authConfig());
  return response.data;
};
